import { Card, CardContent, Grid2 as Grid, Skeleton, Stack, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Section } from '@/components/Section';
import { DynamicIcon } from '@/components/DynamicIcon';
import { usePublicContent } from './use-public-content';
import { useSectionCopy } from './use-section-copy';

/** "Unsere Leistungen" — driven entirely by content managed in the admin panel. */
export function Services() {
  const { t, i18n } = useTranslation();
  const { services, isLoading } = usePublicContent();
  const isDe = i18n.resolvedLanguage !== 'en';
  const copy = useSectionCopy('services', {
    eyebrow: t('services.eyebrow'),
    title: t('services.title'),
    subtitle: t('services.subtitle'),
  });

  return (
    <Section
      id="leistungen"
      eyebrow={copy.eyebrow}
      title={copy.title}
      subtitle={copy.subtitle}
    >
      <Grid container spacing={3}>
        {isLoading
          ? Array.from({ length: 6 }, (_, i) => (
              <Grid key={i} size={{ xs: 12, sm: 6, md: 4 }}>
                <Skeleton variant="rounded" height={188} />
              </Grid>
            ))
          : services.map((service) => (
              <Grid key={service.id} size={{ xs: 12, sm: 6, md: 4 }}>
                <Card
                  sx={{
                    height: '100%',
                    '&:hover': { borderColor: 'text.primary', transform: 'translateY(-2px)' },
                  }}
                >
                  <CardContent sx={{ p: { xs: 3, md: 3.5 } }}>
                    <Stack spacing={1.75}>
                      <DynamicIcon name={service.icon} sx={{ fontSize: 30 }} />
                      <Typography variant="h4" component="h3">
                        {isDe ? service.titleDe : service.titleEn}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {isDe ? service.bodyDe : service.bodyEn}
                      </Typography>
                    </Stack>
                  </CardContent>
                </Card>
              </Grid>
            ))}
      </Grid>
    </Section>
  );
}
